import {
	AccountType,
	Address,
	Condominium,
	CondominiumUserRole,
	Device,
	DomainEvents,
	HousingUnit,
	Message,
	MessageVisibility,
	StorageKeys,
	User,
	UserRole
	} from '../../models/models'
import { ConfigProvider } from '../config/config'
import { Events } from 'ionic-angular'
import { Injectable } from '@angular/core'
import { Logger } from '../../util/logger/logger'
import { Storage } from '@ionic/storage'
import { UserProvider } from '../user/user'
import 'rxjs/add/operator/map'
//import { Http } from '@angular/http';

//import {ApplicationRef } from '@angular/core';

//import {Observable} from 'rxjs/Observable';






declare var window: any;

@Injectable()
export class AuthProvider {
	private static _user: User = null;

	/**
	Id dell'utente auttualmente autenticato, o null
	*/
	public get id(): number {
		return AuthProvider._user ? AuthProvider._user.id : null;
	}


	private logoutTimeout: any;



	public get user(): User {
		return AuthProvider._user;
	}
	public set user(user: User) {
		//console.debug('[AuthController.user set] Utente corrente assegnato: ', user)
		if (window.appContext) {
			let lightCopy: User;
			if (user) {
				lightCopy = { ...user }

				delete lightCopy.accounts
				delete lightCopy.address
				delete lightCopy.contacts
				delete lightCopy.condominiums
				delete lightCopy.housing_units
				delete lightCopy.messages
				delete lightCopy.sentMessages
			}

			window.appContext.user = lightCopy;
		} else {
			console.warn('Login senza window.appContext')
		}
		AuthProvider._user = user;
	}

	constructor(
		//public http: Http,
		//private devices: DeviceProvider,
		//private nav: NavController,
		private events: Events,
		//private platform: Platform,
		private storage: Storage,
		private users: UserProvider
	) {

	}

	/**
	Cerca nello storage eventuali identifier, secret e type per login automatico.
	Se li trova tenta il login.
	Restituisce l'utente eventualmente autenticato, oo null.
	*/
	public autologin(): Promise<User> {
		console.group("[AuthProvider.autologin()] Controllo se è configurato autologin..");
		let self = this;

		return new Promise<User>((success, fail) => {
			/**
			Eventuale auto login
			*/
			self.storage.get(StorageKeys.AUTH_ACCOUNT_IDENTIFIER).then((identifier) => {
				if (identifier) {
					console.debug('[AuthProvider.autologin()] Identifier per autologin trovato in storage: ' + identifier);

					self.storage.get(StorageKeys.AUTH_ACCOUNT_TYPE).then((type) => {
						if (type) {
							console.debug('[AuthProvider.autologin()] Tipo di login trovato in storage:' + type);

							switch (type) {
								case AccountType.PIN:
									self.login(type, identifier, null, true).then(user => {
										console.info('[AuthProvider.autologin()] Autenticazione automatica con PIN eseguita.')
										console.groupEnd()
										success(user)
									}).catch(e => {
										console.error('Errore autenticando con PIN', e)
										console.groupEnd()
										fail('Impossibile verificare il PIN in questo momento')
										//success(null);//fail compromette l'inizializzazione offline
									})
									break;
								case AccountType.EMAIL_PASSWORD:
									self.storage.get(StorageKeys.AUTH_ACCOUNT_SECRET).then((secret) => {
										if (secret) {
											self.login(type, identifier, secret, true).then(user => {
												console.info('[AuthProvider.autologin()] Autenticazione automatica con email+password eseguita.')
												console.groupEnd()
												success(user)
											}).catch(e => {
												console.error('Errore autenticando con email+password persistiti', e)
												console.groupEnd()
												fail('[AuthProvider.autologin()] Impossibile verificare le credenziali salvate in questo momento')
											})
										} else {
											console.error("Secret per il login email+password non persistito, impossibile usare l'identifier persistito per autologin")
											console.groupEnd()
											//success(null);//fail compromette l'inizializzazione offline
											fail('Credenziali salvate non recuperabili')
										}
									})
									break;
								default:
									console.error('Trovato tipo di autenticazione sconosciuto: ' + type)
									console.groupEnd()
									//success(null);//fail compromette l'inizializzazione offline
									fail('Credenziali salvate non recuperabili')
							}
						} else {
							console.error('Trovato identifier senza tipo di autenticazione')
							//success(null);//fail compromette l'inizializzazione
							console.groupEnd()
							fail('Credenziali salvate non recuperabili')
						}

					}).catch(e => {
						console.error("Identifier per il login non persistito, impossibile usare l'identifier persistito per autologin", e)
						console.groupEnd()
						fail('Impossibile autenticare automaticamente, dispositivo offline o credenziali modificate')
					})

				} else {//identifier persistito senza tipo di login specificato
					console.info("[AuthProvider.autologin()] Credenziali non salvate, autologin non attivo")
					console.groupEnd()
					success(null);//ok ma non autenticato
				}

			}).catch(e => {//errore leggendo type
				console.error("Errore l'identifier per autologin persistito", e)
				console.groupEnd()
				fail("Errore leggendo l'identifier per autologin persistito")
			})
		});
	}

	public get isAuth() {
		return AuthProvider._user !== null;
	}

	/*
	CAN*: Controllo permessi utente
	*/

	/*
	INDIRIZZI
	*/
	public canAddressDelete(address: Address) {
		if (!this.isAuth) return false;
		if (address.type == 'location') return false;//I contatti possono essere obbligatori
		if (address.user_id == this.user.id) return true;
		if (address.owner_type == 'App\\User' && address.owner_id == this.id) return true;
		if (address.owner_type == 'App\\Condiminium') {
			if (!address.owner) {
				console.debug('[AuthProvider.canAddressEdit] Impossibile verificare i permessi di eliminazione sull\'indirizzo del condominio, attributo condominio non caricato')
			}
			let condominium = <Condominium>address.owner;
			return this.hasCondominiumRole(condominium, 'is_administrator');//Amministratore può modificare i contatti
		}
		return false;
	}
	public canAddressEdit(address: Address) {
		if (!this.isAuth) return false;
		if (address.user_id == this.user.id) return true;
		if (address.owner_type == 'App\\User' && address.owner_id == this.id) return true;
		if (address.owner_type == 'App\\Condiminium') {
			if (!address.owner) {
				console.debug('[AuthProvider.canAddressEdit] Impossibile verificare i permessi di modifica sull\'indirizzo del condominio, attributo condominio non caricato')
			}
			let condominium = <Condominium>address.owner;
			return this.hasCondominiumRole(condominium, 'is_administrator');//Amministratore può modificare i contatti
		}
		return false;
	}

	//CONDOMINIO
	/**
	Verifica se l'utente autenticato può eliminare il condominio
	*/
	public canCondominiumDelete(_condominium: Condominium) {
		if (!this.user) return false;
		if (this.user.is_admin || this.user.is_operator) return true;
		return false;
	}
	public canCondominiumEdit(condominium: Condominium): any {
		if (!condominium) {
			console.warn('Impossibile controllare i permessi di modifica per condominio null');
			return false;
		}
		if (!this.user) return false;
		if (this.hasRole(['is_admin', 'is_operator'])) return true;//superuser possono sempre modificare
		if (!this.user.is_administrator) return false;//solo gli amministratori possono modificare

		//solo amministratore del condominio può modificare
		return this.hasCondominiumRole(condominium, 'is_administrator');
	}
	/**
	Verifica se l'utente corrente può effettuare login sul dispositivo passato
	*/
	public canCondominiumLogin(condominium: Condominium) {
		if (!this.user) return false;
		if (this.hasRole(['is_admin', 'is_operator'])) return true;
		if (!condominium) {
			console.warn("Condominio non valorizzato");
			return false;
		}

		/*se ha un ruolo nel condominio lo può vedere*/
		if (this.hasCondominiumRole(condominium)) {
			return true;
		}

		/*
		se è di una unità immobliare lo può vedere
		*/
		if (this.hasHousingUnitsRole(condominium)) {
			return true;
		}

		console.log('Non può fare login sui dispositivi del condominio: ', condominium);

		return false;
	}
	/**
	Può aprire il portone del condominio
	*/
	public canCondominiumOpen(condominium: Condominium, user: User = null) {
		if (!user) {
			user = this.user;
		}
		if (!user) return false;

		if (user.is_admin || user.is_operator) return true;
		if (this.hasCondominiumRole(condominium, null, user)) return true;
		if (this.hasHousingUnitsRole(condominium, null, user)) return true;

		return false;
	}
	/**
	verifica se l'utente autenticato può rimuovere il ruolo dato dal condominio
	*/
	public canCondominiumRoleRemove(condominium: Condominium, role: CondominiumUserRole) {
		if (!this.user) return false;
		if (!role) return false;//se non ha un ruolo non può rimuoverlo
		if (this.hasRole([UserRole.is_admin, UserRole.is_operator])) return true;//superuser possono sempre modificare
		if (role == CondominiumUserRole.is_administrator) return false;//gli amministratori possono essere rimossi solo da superuser
		if (!this.hasRole([UserRole.is_administrator])) return false;//solo gli amministratori possono disassociare i ruoli
		if (role != CondominiumUserRole.is_worker && role != CondominiumUserRole.is_heatingreader) {
			console.warn('Verificata la rimovibilità di un ruolo non valido: ' + role);
			return false;
		}
		//se è amministratore su questo condominio può disassociare addetti e letturisti
		if (this.hasCondominiumRole(condominium, [CondominiumUserRole.is_heatingreader, CondominiumUserRole.is_worker])) {
			return true;
		}

		//altrimenti non era amministratore su questo condominio
		return false;
	}
	/**
	Verifica se l'utente corrente può visualizzare il condominio passato
	*/
	public canCondominiumShow(condominium: Condominium) {
		if (!this.user) return false;
		if (this.hasRole(['is_admin', 'is_operator'])) return true;
		if (!condominium) {
			console.warn("Condominio non valorizzato");
			return false;
		}

		/*se ha un ruolo nel condominio lo può vedere*/
		if (this.hasCondominiumRole(condominium)) {
			return true;
		}

		/*
		se è di una unità immobliare lo può vedere
		*/
		if (this.hasHousingUnitsRole(condominium)) {
			return true;
		}
		/*
		for (let housingUnit of condominium.housing_units) {
		if (!housingUnit.user_roles) {
		console.warn("Ruoli utente dell'unità abitativa del condominio non caricati");
	} else for (let user of housingUnit.user_roles) {
	if (user.user_id == this.user.id) {
	return true;
	}
	}
	}
	*/

		console.log('Condominio non visualizzabile: ', condominium);

		return false;
	}

	//DISPOSITIVO

	public canDeviceDelete(_device: Device): boolean {
		return this.hasRole(['is_admin', 'is_operator']);
	}
	public canDeviceEdit(_device: Device): boolean {
		return this.hasRole(['is_admin', 'is_operator']);
	}
	public canDeviceShow(_device: Device): boolean {
		return this.hasRole(['is_admin', 'is_operator']);
	}

	//UNITA IMMOBILIARI

	/**
	Verifica se può aggiungere una unità abitativa al condominio
	*/
	public canHousingUnitCreate(condominium: Condominium) {//deve specificare il condominio
		if (!this.isAuth) {
			return false;
		}

		if (!condominium) {
			console.warn('Impossibile controllare i permessi di modifica per condominio null');
			return false;
		}

		if (!this.user) return false;

		if (this.hasRole(['is_admin', 'is_operator'])) return true;//superuser possono sempre creare U.I.
		if (!this.user.is_administrator) return false;//solo gli amministratori possono creare U.I.

		//tra gli amministratori solo amministratore del condominio può aggiungere U.I.
		return this.hasCondominiumRole(condominium, 'is_administrator');
	}

	/**
	Visualizza dettagli unità abitativa
	*/
	public canHousingUnitDelete(housingUnit: HousingUnit) {
		if (!this.isAuth) {
			return false;
		}

		if (!housingUnit) {
			console.warn('Impossibile controllare i permessi di modifica per unità abitativa null');
			return false;
		}

		if (!this.user) return false;

		if (this.hasRole(['is_admin', 'is_operator'])) return true;//superuser possono sempre creare U.I.

		if (!housingUnit.condominium) {
			console.warn('Condominio non caricato, impossibile stabilire se l\'amministratore ha il privileggio su questa unità abitativa')
		}
		if (this.hasCondominiumRole(housingUnit.condominium_id, ['is_administrator'])) return true;//amministratori possono vedere i dettagli
	}

	/**
	Visualizza dettagli unità abitativa
	*/
	public canHousingUnitEdit(housingUnit: HousingUnit) {
		if (!this.isAuth) {
			return false;
		}

		if (!housingUnit) {
			console.warn('Impossibile controllare i permessi di modifica per unità abitativa null');
			return false;
		}

		if (!this.user) return false;

		if (this.hasRole(['is_admin', 'is_operator'])) return true;//superuser possono sempre creare U.I.

		if (this.hasHousingUnitRole(housingUnit)) return true;//proprietario o residente

		if (!housingUnit.condominium) {
			console.warn('Condominio non caricato, impossibile stabilire se l\'amministratore ha il privileggio su questa unità abitativa')
		}
		if (this.hasCondominiumRole(housingUnit.condominium_id, ['is_administrator'])) return true;//amministratori possono vedere i dettagli
	}

	/**
	Visualizza dettagli unità abitativa
	*/
	public canHousingUnitShow(housingUnit: HousingUnit) {
		if (!this.isAuth) {
			return false;
		}

		if (!housingUnit) {
			console.warn('Impossibile controllare i permessi di visualizzazione per unità abitativa null');
			return false;
		}

		if (!this.user) return false;

		if (this.hasRole(['is_admin', 'is_operator'])) return true;//superuser possono sempre creare U.I.

		if (this.hasHousingUnitRole(housingUnit)) return true;//proprietario o residente

		if (!housingUnit.condominium) {
			console.warn('[AuthProvider.canHousingUnitShow()] Condominio non valorizzato sull\'unità immobiliare, impossibile stabilire se l\'amministratore ha il privileggio su questa unità abitativa')
		}
		if (this.hasCondominiumRole(housingUnit.condominium_id, ['is_administrator'])) return true;//amministratori possono vedere i dettagli
		console.debug('[AuthProvider.canHousingUnitShow()] Utente non è amministratore sul condominio dell\'unità immobiliare',this.user,housingUnit.condominium);

		return false;
	}

	/**
	Permessi per aggiungere un utente ad una unità abitativa
	*/
	public canHousingUnitUserAdd(housingUnit: HousingUnit): any {
		if (!this.isAuth) {
			return false;
		}

		if (!housingUnit) {
			console.warn('Impossibile controllare i permessi di aggiunta utente per unità abitativa null');
			return false;
		}

		if (!this.user) return false;

		//sviluppatore o operatore
		if (this.hasRole(['is_admin', 'is_operator'])) return true;//superuser possono sempre creare U.I.

		if (!housingUnit.condominium) {
			console.warn('Impossibile controllare i permessi di aggiunta utente per unità abitativa con condominio nullo');
			return false;
		}
		//amministratore di condominio
		return this.hasCondominiumRole(housingUnit.condominium, 'is_administrator')

	}
	//MESSAGGIO

	public canMessageDelete(message: Message): boolean {
		if (!this.isAuth) {
			return false;
		}
		if (message.sender_id) {//se ha un mittente solo il mittente può eliminarlo
			if (message.receiver_type == 'App\\Condominium') {
				if (!message.receiver) {
					console.warn('Destinatario messaggio non caricato, impossibile verificare se l\'utente può archiviare il messaggio')
					return false;
				}
				//l'amministratore può eliminare i messaggi del condominio
				return this.hasCondominiumRole(<Condominium>message.receiver, 'is_administrator');
			}
			if (message.sender_type == 'App\\User' && this.user.id == message.sender_id) {//elimina per tutti
				return true;
			}
		} else {
			//può nasconderlo e non ha mittente => può cancellarlo
			return this.canMessageHide(message);
		}
		return false;
	}

	/**
	Verifica se può archiviare il messaggio
	*/
	public canMessageHide(message: Message) {
		if (!this.isAuth) {
			return false;
		}

		//se mittente ok
		if (message.sender_type == 'App\\User' && message.sender_id == this.user.id) return true;

		if (!message.receiver) {
			console.warn('Destinatario messaggio non caricato, impossibile verificare se l\'utente può archiviare il messaggio')
			return false;
		}

		//destinatario: cambia in base al tipo
		switch (message.receiver_type) {
			case 'App\\Condominium'://per condominio: deve essere amministratore
				if (this.hasCondominiumRole(<Condominium>message.receiver, 'is_administrator')) return true;
				break;
			case 'App\\User'://per utente: ok se destinatario
				if (message.receiver_id == this.user.id) return true;
				break;
			case 'App\\HousingUnit':
				if (this.hasHousingUnitRole(<HousingUnit>message.receiver, 'is_resident')) return true;//è residente nell'unità abitativa
				break;
		}

		return false;
	}

	public canMessageShow(message: Message): boolean {
		if (message.visibility == MessageVisibility.PUBLIC) {//Se il messaggio è pubblico si
			return true;
		}

		if (!this.user) {//messaggio privato e utente non autenticato
			//console.debug('[AuthProvider.canMessageShow()] Utente non autenticato: Messaggio non visibile')
			return false;
		}
		if (message.sender_id && this.user.id == message.sender_id) {//mittente
			return true;
		}

		switch (message.receiver_type) {
			case 'App\\Condominium':
				let condominium: Condominium;
				if (message.receiver_id == message.condominium_id && message.condominium) {
					condominium = message.condominium;//Uso questo perchè ha caricati i ruoli a differenza del destinatario generico
				} else {
					condominium = <Condominium>message.receiver;
				}

				//console.debug('[AuthProvider.canMessageShow(message)] Verifico la visibilità del messaggio per il condominio da parte dell\'utente attuale', message, condominium)
				let hasCondominiumRole = this.hasCondominiumRole(condominium);
				if (!hasCondominiumRole) {
					//console.debug('[AuthProvider.canMessageShow(message)] Questo utente non ha ruoli nel condominio', this.user, condominium)
				} else {
					return true;
				}
				return this.hasHousingUnitsRole(condominium);//deve avere un ruolo qualunque nel condominio o nelle unità del condominio
			case 'App\\HousingUnit':
				let housingUnit: HousingUnit = <HousingUnit>message.receiver;
				return this.hasHousingUnitRole(housingUnit);//deve avere un ruolo qualunque nell'unità abitativa
			case 'App\\User':
				return this.user.id == message.receiver_id;
		}
		console.debug('Non può visualizzare il messaggio')
		return false;
	}



	//UTENTE

	public canRemoveHousingUnitUser(housingUnit: HousingUnit, user: User, role: String): boolean {
		if (!this.user) return false;

		//superutenti tolgono tutti
		if (this.hasRole(['is_admin', 'is_operator'])) return true;

		if (!role) {
			console.warn('auth.canRemoveHousingUnitUser(): ruolo non specificato');
			return false;
		}
		if (!housingUnit) {
			console.warn('auth.canRemoveHousingUnitUser(): unità abitativa non specificata');
			return false;
		}


		if (housingUnit.condominium && this.hasRole('is_administrator')) {//amministratori del condominio possono
			if (this.hasCondominiumRole(housingUnit.condominium, 'is_administrator')) return true;
		}

		//altrimenti solo proprietari possono rimuovere residenti
		return this.hasHousingUnitRole(housingUnit, 'is_owner') && this.hasHousingUnitRole(housingUnit, 'is_resident', user);
	}

	public canRemoveCondominiumUser(condominium: Condominium, user: User, role: String): boolean {
		if (!this.user) return false;

		//superutenti tolgono tutti
		if (this.hasRole(['is_admin', 'is_operator'])) return true;

		//solo i superuser possono togliere amministratori
		if (role == 'is_administrator') return false;

		if (!role) {
			console.warn('auth.canRemoveCondominiumUser(): ruolo non specificato');
			return false;
		}
		if (!condominium) {
			console.warn('auth.canRemoveCondominiumUser(): condominio non specificato');
			return false;
		}

		//solo gli amministratori possono rimuovere ruoli
		if (!this.hasRole('is_administrator')) return false;

		//solo a non amministratori
		return !this.hasCondominiumRole(condominium, 'is_administrator', user);
	}


	/**
	Verifica se l'utente autenticato può modificare l'utente passato
	*/
	public canUserEdit(user: User): boolean {

		if (!user || !this.user) return false;

		if (this.user.id == user.id) return true;//se stesso si

		//admin solo da se stesso
		if (this.hasRole(['is_admin'], user)) return false;

		//superutenti modifcano tutti, tranne admin
		if (this.hasRole(['is_admin', 'is_operator'])) return true;

		//nessun altro può modificare operatori
		if (this.hasRole(['is_operator'])) return false;

		if (this.user.is_administrator) {
			if (user.condominiums) {
				for (let condominium of user.condominiums) {
					if (
						this.hasCondominiumRole(condominium, ['is_administrator'])
						&& !this.hasCondominiumRole(condominium, ['is_administrator'], user)
					) {
						//se è amministratore e l'altro ha un ruolo ma non è amminstratore può modificarlo
						return true;
					}
				}
			}

			return this.hasUserHousingUnitsCondominiumRole(user, 'is_administrator');
		}

		return false;
	}

	/**
	Controlla se l'utente autenticato può modificare C.F o P.IVA del soggetto
	- user: Il soggetto
	*/
	public canUserEditFiscalIdentifier(user: User): boolean {
		if (!this.canUserEdit(user)) {
			return false;
		}

		//Solo gli amministratori possono modificare i ruoli degli utenti che modificano
		return this.hasUserCondominiumRole(user, 'is_administrator')
			|| this.hasUserHousingUnitsCondominiumRole(user, 'is_administrator');
	}
	/**
	Verifica se può visualizzare l'utente
	*/
	public canUserShow(user: User): boolean {
		if (!user || !this.user) return false;

		if (this.user.id == user.id) return true;//se stesso si

		//admin non può essere visualizzato da altri
		if (this.hasRole(['is_admin'], user)) return false;

		//superutenti vedono tutti gli altri
		if (this.hasRole(['is_admin', 'is_operator'])) return true;

		//nessun altro può vedere operatori
		if (this.hasRole(['is_operator'])) return false;

		if (user.condominiums && (this.user.is_administrator || this.user.is_heatingreader || this.user.is_worker)) {
			//se ha ruoli nel condominio si

			for (let condominium of user.condominiums) {
				if (this.hasCondominiumRole(condominium)) return true;
			}
		}

		if (user.housing_units) {
			//se ha ruoli nelle unità immobliari o nei condomini delle stesse si

			for (let housingUnit of user.housing_units) {
				if (this.hasHousingUnitRole(housingUnit)) return true;//se ruoli nelle stesse unità immobiliari si

				if (housingUnit.condominium) {
					if (this.hasCondominiumRole(housingUnit.condominium)) return true;//se l'utente attuale ha ruolo nel condominio può vederlo
				}
			}
		}

		return false;
	}


	public clearLogoutTimeout() {
		if (this.logoutTimeout) {
			clearTimeout(this.logoutTimeout);
			this.logoutTimeout = null;
		}
	}


	/**
	Controlla se l'utente ha il ruolo
	- user: opzionale, se non passato usa l'utente autenticato
	*/
	public hasRole(rolenames: string[] | string, user: User = this.user) {
		if (!rolenames) {
			return false;
		}
		if (!user) {
			return false;
		}

		if (typeof rolenames == 'string') {
			rolenames = [rolenames];
		}

		for (let rolename of rolenames) {
			if (user[rolename]) return true;
		}
		return false;
	}

	/**
	Controlla se l'utente ha un ruolo sul condominio:
	- condominium: il condominio su cui verificare i ruoli, o id per verificare usando i condomini dell'utente
	- rolenames: Se non passato o null controlla se ha un ruolo qualunque, altrimenti verifica questi ruoli specifici (stringa o array di stringhe)
	- user: l'utente di cui verificare i ruoli sul condominio, default l'utente autenticato
	*/
	public hasCondominiumRole(
		condominium: Condominium | number,
		rolenames: string[] | string = ['is_administrator', 'is_worker', 'is_heatingreader'],
		user: User = this.user
	) {
		if (!user) {
			return false;
		}
		if (!condominium) {
			return false;
		}
		if (!rolenames) {
			return false;
		}
		if (typeof rolenames == 'string') {
			rolenames = [rolenames];
		}

		console.debug('[AuthProvider.hasCondominiumRole()] Verifica amministratore condominio',{condominium,rolenames,user});


		if (user.condominiums) {
			for (let userCondominium of user.condominiums) {
				let found = (typeof (condominium) == 'number'||typeof (condominium) == 'string')? userCondominium.id == condominium: userCondominium.id == condominium.id;

				if (found) {//è questo
					for (let rolename of rolenames) {
						if (user[rolename] && userCondominium.pivot[rolename]) return true;//ha il ruolo globale o lo ha sul pivot col condominio
					}
				}
			}
		}

		if (typeof (condominium) == 'number'||typeof (condominium) == 'string') {//Se era passato per id, non può fare altri controlli
			if (!this.user.condominiums) {
				console.warn("Condomini utente non caricati, impossibile verificare i ruoli nel condominio passato per id");
			}
			return false;
		} else {//condominio oggetto: cerca nei riferimenti da condominio a utenti
			if (!condominium.users && !condominium.user_roles) {
				console.warn("Utenti e ruoli utenti del condominio dell'unità abitativa non caricati");
				return false;
			}

			for (let rolename of rolenames) {
				if (user[rolename]) {
					//per attivare i ruolo condominiali serve il ruolo globale
					if (condominium.users) {
						for (let condominiumUser of condominium.users) {
							if (condominiumUser.id == user.id && condominiumUser.pivot[rolename]) return true;
						}
					} else if (condominium.user_roles) {
						for (let role of condominium.user_roles) {
							if (role.user_id == user.id && role[rolename]) return true;
						}
					} else {
						console.warn('Impossibile verificare il ruolo dell\'utente sul condominio, il condominio non ha caricato ne users ne user_roles');
					}
				}
			}
		}
		return false;
	}

	/**
	Controlla se l'utente ha un ruolo sull'unità immobliare:
	- housingUnit: l'unità abitativa su cui verificare i ruoli
	- rolenames: Se non passato o null controlla se ha un ruolo qualunque, altrimenti verifica questi ruoli specifici (stringa o array di stringhe)
	- user: l'utente di cui verificare i ruoli, default l'utente autenticato
	*/
	public hasHousingUnitRole(
		housingUnit: HousingUnit,
		rolenames: string[] | string = null,
		user: User = this.user
	) {
		if (!user) {
			return false;
		}
		if (!housingUnit) {
			return false;
		}

		if (rolenames === null) {
			rolenames = ['is_owner', 'is_resident'];
		} else if (!rolenames) {//stringa o array vuoto
			return false;
		} else if (typeof rolenames == 'string') {
			rolenames = [rolenames];
		}

		if (!housingUnit.users && !housingUnit.user_roles && !user.housing_units) {
			console.warn("Utenti e ruoli utenti dell'unità abitativa ne unità immobiliari dell'utente caricate, impossibile verificare i ruoli sulle unità immobiliari");
		} else {
			for (let rolename of rolenames) {
				if (housingUnit.users) {
					for (let checkedUser of housingUnit.users) {
						if (checkedUser.id == user.id && checkedUser.pivot[rolename]) return true;
					}
				} else if (housingUnit.user_roles) {
					for (let role of housingUnit.user_roles) {
						if (role.user_id == user.id && role[rolename]) return true;
					}
				} else {
					//relazione inversa, da utente a unità immobliare

					for (let userHousingUnit of user.housing_units) {
						if (userHousingUnit.id == housingUnit.id && userHousingUnit.pivot && userHousingUnit.pivot[rolename]) return true;
					}
				}
			}
		}
		return false;
	}


	/**
	Controlla se l'utente ha un ruolo su una delle unità immobiliari del condominio
	- condominium: il condominio dal quale prendere le unità immobiliari su cui verificare i ruoli
	- rolenames: Se non passato o null controlla se ha un ruolo qualunque, altrimenti verifica questi ruoli specifici (stringa o array di stringhe)
	- user: l'utente di cui verificare i ruoli sul condominio, default l'utente autenticato
	*/
	public hasHousingUnitsRole(
		condominium: Condominium,
		rolenames: string[] | string = null,
		user: User = this.user
	) {
		if (!user) {
			return false;
		}
		if (!condominium) {
			return false;
		}
		if (!condominium.housing_units && !user.housing_units) {
			return false;
		}

		if (rolenames === null) {
			rolenames = ['is_owner', 'is_resident'];
		} else if (!rolenames) {//stringa o array vuoto
			return false;
		} else if (typeof rolenames == 'string') {
			rolenames = [rolenames];
		}


		if (condominium.housing_units) {
			for (let housingUnit of condominium.housing_units) {
				if (this.hasHousingUnitRole(housingUnit, rolenames, user)) {
					return true;
				}
			}
		}
		//controlla inversamente dalle unità dell'utente all'id del condominio
		if (user.housing_units) {
			for (let housingUnit of user.housing_units) {
				if (housingUnit.condominium_id == condominium.id && this.hasHousingUnitRole(housingUnit, rolenames, user)) {
					return true;
				}
			}
		}
		return false;
	}

	/**
	Verifica se l'utente autenticato ha uno dei ruoli in uno dei condomini dell'utente passato.
	Se non sono passati ruoli verifica almeno un ruolo qualunque
	*/
	public hasUserCondominiumRole(
		other: User,
		roles: string | string[] = ['is_administrator', 'is_worker', 'is_heatingreader'],
		user: User = this.user
	) {
		if (other.condominiums) {
			for (let condominium of other.condominiums) {
				if (this.hasCondominiumRole(condominium, roles, user)) {
					return true;
				}
			}
		}
		return false;
	}
	/**
	Controlla se l'utente autenticato ha un ruolo in un condominio delle unità immobiliari dell'utente passato
	Se non vengono passati ruoi controlla che abbia almeno un ruolo qualunque
	- other: L'utente di cui verificare i condomini delle unità immobiliari (proprietario o residente)
	- roles: I ruoli da verificare, default tutti
	- user: L'utente che deve avere i ruoli
	*/
	public hasUserHousingUnitsCondominiumRole(
		other: User,
		roles: string | string[] = ['is_administrator', 'is_heatingreader', 'is_worker'],
		user: User = this.user
	): boolean {
		if (other.housing_units) {
			for (let housingUnit of other.housing_units) {
				//se è amministratore per un condominio dell'utente ok
				if (this.hasCondominiumRole(housingUnit.condominium, roles, user)) return true;
			}
		}
		return false;
	}

	/**
	Autentica l'utente corrente

	- type : Tipo autenticazione
	- identifier : email o PIN
	- secret : password
	- remember : se ok salva per autologin al successivo avvio
	*/
	public login(type: AccountType, identifier: string, secret: string = null, remember: boolean = false): Promise<User> {
		console.group('[AuthProvider.login()] Autenticazione', type, identifier, secret, remember)
		if (this.isAuth) {
			this.logout();
		}

		let self = this;
		return new Promise((resolve, reject) => {
			if (identifier === null || (type == 'email_password' && secret === '')) {
				reject("Credenziali incomplete");
				return;
			}

			self.users.login(type, identifier, secret, ['condominiums', 'housingUnits'], remember).then(result => {
				if (result) {
					console.info('[AuthProvider.login()] Credenziali verificate corrette')
					self.user = result;
					self.events.publish(DomainEvents.USER_LOGIN, result, Date.now());

					if (remember) {
						console.debug('Login con remember attivo, salvataggio credenziali nello storage..');
						let saved = [];
						saved.push(self.storage.set(StorageKeys.AUTH_ACCOUNT_IDENTIFIER, identifier));
						saved.push(self.storage.set(StorageKeys.AUTH_ACCOUNT_SECRET, secret));
						saved.push(self.storage.set(StorageKeys.AUTH_ACCOUNT_TYPE, type));

						Promise.all(saved).then(() => {
							console.debug('Credenziali per autologin persistite.')

							self.storage.forEach((v, k) => {
								console.debug('Valore in storage: ' + k + '=' + v)
							}).then(() => {
								console.groupEnd()
							}).catch(e => {
								console.warn('Errore iterando i valori nello storage', e)
								console.groupEnd()
							})
						}).catch((error) => {
							console.error('Errore persistendo le credenziali per autologin:', error)
							console.groupEnd()
						})

					} else {//fine senza salvare
						console.debug('Login con remember disabilitato, fine.');
						console.groupEnd()
					}
				} else {//server contattato ma nessun utente corrispondente
					self.user = null;
					console.debug('[AuthProvider.login()] Credenziali non corrette')
					console.groupEnd()
				}

				resolve(result);
			}).catch(error => {
				console.warn("[AuthProvider.login()] Errore verificando l'utente sul server:", error)
				console.groupEnd()
				reject("Impossibile verificare l'utente sul server in questo momento");
			})
		})
	}

	public logout() {
		let user = this.user;
		this.user = null;

		console.debug('[AuthProvider.logout()] Elimino eventuali credenziali dallo storage..');
		this.storage.remove(StorageKeys.AUTH_ACCOUNT_IDENTIFIER);
		this.storage.remove(StorageKeys.AUTH_ACCOUNT_SECRET);
		this.storage.remove(StorageKeys.AUTH_ACCOUNT_TYPE);


		this.clearLogoutTimeout();

		if (user) {//se era effettivamente autenticato segnala il logout
			console.debug('[AuthProvider.logout()] Eseguito il logout di utente autenticato')
			this.events.publish(DomainEvents.USER_LOGOUT, user, Date.now());
		}
	}


	/**
	Ricarica i dati dell'utente autenticato
	*/
	public refresh(loads: string[] = ['condominiums', 'housingUnits']): Promise<User> {
		if (!this.isAuth) {
			Logger.error("Tentativo di aggiornare l'utente da autenticato", null, 'AuthProvider.refresh()')
			return Promise.reject('Non autenticato');
		}

		return new Promise((resolve, reject) => {
			this.users.getById(this.user.id, loads).then((user: User) => {
				if (!user) {
					console.warn("[AuthProvider.refresh()] Impossibile recuperare il profilo dell'utente corrente");
				}
				this.user = user;
				resolve(user);
			}).catch(error => {
				reject(error);
			});
		});
	}


	/**
	(re) imposta il logout automatico dopo ConfigProvider.TIMEOUT_INTERACTION secondi da ora
	*/
	public setLogoutTimeout() {
		let self = this;

		this.clearLogoutTimeout();

		/*auto logout dopo X secondi*/
		this.logoutTimeout = setTimeout(() => {
			try {
				console.log('Logout per timeout..');
				self.logout();
				//il logout reimposta la root in automatico
			} catch (e) {
				//se è già dismesso lancia eccezione, ignora
				console.error('Errore: ' + e);
			}
		}, ConfigProvider.TIMEOUT_INTERACTION * 1000);
	}
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts